<template>
  <v-app id="inspire" class="fill-height">
    <v-main style="overflow: hidden">
      <video id="background-video" muted>
        <source src="../assets/Depositphotos_151324262_1080p.mp4" type="video/mp4" />
      </video>
      <v-container>
        <v-row align="center" justify="center">
          <v-col>
            <div class="fixed">
              <img class="tokenImageProfile" :src="img_quickproject" />
              <div class="fixed2">
                <v-card-subtitle style="color: #3f51b5; font-size: 35px; line-height: 1; text-align: center; font-weight: bold; border-radius: 0px 5px 0px 10px; margin-top: 20px; margin-bottom: 20px" class="text">Meeting Quickproject</v-card-subtitle>
                <div class="fixed3">
                  <v-card-subtitle style="color: #3f51b5; font-size: 25px; line-height: 1; text-align: center; font-weight: bold; border-radius: 0px 5px 0px 10px; margin-top: 20px; margin-bottom: 20px" class="text">
                    {{ card_title }}
                    <br />
                    {{ card_title2 }}
                  </v-card-subtitle>
                  <template v-if="!hide_btn">
                    <div v-for="(item, i) in disponibilita" :key="i" class="pb-5">
                      <v-btn :loading="loading3" :disabled="loading3" x-large rounded color="indigo" @click="setRiunione(formatFullDate(item[0]), formatFullDate(item[1]))">
                        <span style="color: white">{{ formatDate(item[0]) }} &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;{{ formatDateTime(item[0]) }} - {{ formatDateTime(item[1]) }}</span>
                      </v-btn>
                    </div>
                  </template>
                </div>
              </div>
            </div>
          </v-col>
        </v-row>

        <div style="position: absolute; bottom: 0px; right: 0px; color: gray; font-size: 12px; padding: 2px">v.{{ this.$store.state.versione }}</div>
      </v-container>
      <!-- Overlay -->
      <v-overlay color="rgba(0, 0, 0, 1)" style="position: absolute" :value="caricamento_dati">
        <v-icon class="ConsuntivoWORuota" size="100">mdi-cog</v-icon>
        <v-icon class="ConsuntivoWOControruota" size="100">mdi-cogs</v-icon>
      </v-overlay>
      <SnackbarQV ref="SnackbarQV" />
    </v-main>
  </v-app>
</template>

<script>
import moment from "moment";
import SnackbarQV from "@/components/TOOLS/SnackbarQV.vue";
export default {
  name: "RecuperoPassword",
  components: {
    SnackbarQV,
  },
  props: {
    obbligatorio: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      card_title: "",
      card_title2: "",
      tmp_token: "",
      riunione: {},
      partecipanti: [],
      loading3: false,
      caricamento_dati: false,
      hide_btn: false,
      disponibilita: [],
      img_quickproject: null,
    };
  },
  methods: {
    formatDate(arg) {
      return arg != null && arg != "" ? moment(arg).format("YYYY-MM-DD") : "";
    },

    formatFullDate(arg) {
      return arg != null && arg != "" ? moment(arg).format("YYYY-MM-DD HH:mm") : "";
    },

    formatDateTime(arg) {
      return arg != null && arg != "" ? moment(arg).format("HH:mm") : "";
    },

    async getTempToken() {
      const request = {
        controller: "global",
        method: "POST",
        richiesta: {
          action: "gettemptoken",
        },
      };

      this.caricamento_dati = true;
      return this.$store
        .dispatch("api6", request)
        .then((response) => {
          this.caricamento_dati = false;
          if (response.status == "200") {
            this.tmp_token = response.data.result;
            return true;
          } else {
            this.$refs.SnackbarQV.print("error", "Errore di comunicazione con il server.");
            this.loading3 = false;
            return false;
          }
        })
        .catch(() => {
          this.caricamento_dati = false;
          this.$refs.SnackbarQV.print("error", "Errore di comunicazione con il server.");
          this.loading3 = false;
          return false;
        });
    },

    async getRiunione() {
      this.card_title2 = "";

      const request = {
        controller: "contabilita",
        method: "POST",
        richiesta: {
          action: "getriunione",
          token: this.tmp_token,
          psw_riunione: this.obbligatorio,
        },
      };

      this.caricamento_dati = true;
      return this.$store
        .dispatch("api6", request)
        .then((response) => {
          this.caricamento_dati = false;
          if (response.status == "200") {
            if (response.data.result.riunioni && response.data.result.riunioni.length > 0) {
              this.riunione = response.data.result.riunioni[0] ? response.data.result.riunioni[0] : {};
              this.partecipanti = response.data.result.partecipanti ? response.data.result.partecipanti : [];
              this.img_quickproject = response.data.result.img_quickproject[0].img_modulo ? response.data.result.img_quickproject[0].img_modulo : null;

              if (this.riunione.data_conferma) {
                this.card_title = "Riunione confermata per la data:";
                this.card_title2 = this.riunione.data_conferma;
                this.hide_btn = true;
              } else {
                this.card_title = "Selezionare una data per la riunione:";
              }
            } else {
              this.card_title = "Riunione non esistente.";
              this.hide_btn = true;
            }
            return true;
          } else {
            this.$refs.SnackbarQV.print("error", "Errore di comunicazione con il server.");
            return false;
          }
        })
        .catch(() => {
          this.caricamento_dati = false;
          this.$refs.SnackbarQV.print("error", "Errore di comunicazione con il server.");
          return false;
        });
    },

    async getDisponibilita() {
      const request = {
        controller: "wsGraph",
        method: "POST",
        richiesta: {
          action: "listacalendaridisponibilita",
          token: this.tmp_token,
          psw_riunione: this.obbligatorio,
        },
      };

      this.caricamento_dati = true;
      return this.$store
        .dispatch("api", request)
        .then((response) => {
          this.caricamento_dati = false;
          if (response.status == "200") {
            this.disponibilita = response.data.disponibilita ? response.data.disponibilita : [];
            return true;
          } else {
            this.$refs.SnackbarQV.print("error", "Errore di comunicazione con il server.");
            return false;
          }
        })
        .catch(() => {
          this.caricamento_dati = false;
          this.$refs.SnackbarQV.print("error", "Errore di comunicazione con il server.");
          return false;
        });
    },

    async setRiunione(data_inizio, data_fine) {
      let subject = JSON.parse(JSON.stringify(this.riunione.evento_oggetto));
      subject = await this.parsePlaceholder(subject, this.riunione);
      let content = JSON.parse(JSON.stringify(this.riunione.evento_testo));
      content = await this.parsePlaceholder(content, this.riunione);

      let attendees = [];

      this.partecipanti.forEach((partecipante) => {
        if (partecipante.email)
          attendees.push({
            emailAddress: {
              address: partecipante.email,
              name: partecipante.nominativo,
            },
            type: "required",
          });
      });

      let evento = {
        subject: subject,
        body: {
          contentType: "HTML",
          content: content,
        },
        start: {
          dateTime: moment(new Date(data_inizio)).format("YYYY-MM-DDTHH:mm:ss"),
          timeZone: "W. Europe Standard Time",
        },
        end: {
          dateTime: moment(new Date(data_fine)).format("YYYY-MM-DDTHH:mm:ss"),
          timeZone: "W. Europe Standard Time",
        },
        attendees: attendees,
        isOnlineMeeting: true,
        onlineMeetingProvider: "teamsForBusiness"
      };

      var request = {
        controller: "contabilita",
        method: "PUT",
        richiesta: {
          action: "setdatariunione",
          token: this.tmp_token,
          psw_riunione: this.obbligatorio,
          data_inizio: data_inizio,
          data_fine: data_fine,
        },
      };

      this.caricamento_dati = true;
      this.$store
        .dispatch("api6", request)
        .then((response) => {
          if (response.status == "200") {
            var request2 = {
              controller: "wsGraph",
              method: "POST",
              richiesta: {
                action: "creaeventocalendario",
                token: this.tmp_token,
                organizzatore: this.riunione.email,
                evento: evento,
                psw_riunione: this.obbligatorio,
              },
            };

            this.$store
              .dispatch("api", request2)
              .then((response) => {
                this.caricamento_dati = false;
                if (response.status == "200") {
                  this.$refs.SnackbarQV.print("success", "Data confermata con successo.");
                } else {
                  this.loading3 = false;
                  this.$refs.SnackbarQV.print("error", "Errore di comunicazione con il server.");
                }
              })
              .catch(() => {
                this.caricamento_dati = false;
                this.$refs.SnackbarQV.print("error", "Errore di comunicazione con il server.");
              })
              .then(() => {
                this.getRiunione();
              });
          } else {
            this.caricamento_dati = false;
            this.$refs.SnackbarQV.print("error", "Errore di comunicazione con il server.");
          }
        })
        .catch(() => {
          this.caricamento_dati = false;
          this.$refs.SnackbarQV.print("error", "Errore di comunicazione con il server.");
        });
    },

    async parsePlaceholder(str, object) {
      if (!str || str == "") {
        return str;
      } else {
        let arrStr = str.split(/[{}]/);
        if (arrStr.length < 2) {
          return str;
        } else {
          let str_parse = JSON.parse(JSON.stringify(str));
          let value = object[arrStr[1]] ? object[arrStr[1]] : "";
          str_parse = str_parse.replace("{" + arrStr[1] + "}", value ? value : "");
          return await this.parsePlaceholder(str_parse, object);
        }
      }
    },
  },

  async mounted() {
    await this.getTempToken();
    await this.getRiunione();

    if (!this.riunione.data_conferma) {
      await this.getDisponibilita();
    }
  },
};
</script>

<style scoped>
#background-video {
  width: 110vw;
  height: 110vh;
  position: fixed;
  left: -30px;
  top: 0;
  filter: opacity(0.96) drop-shadow(0 0 0 rgb(255, 255, 255)) blur(18px) brightness(1.1);
}
</style>
<style lang="scss" scoped>
.tokenImageProfile {
  margin: 10px 10px 10px 10px;
  border-radius: 0.5rem;
  height: 110px;
}

.fixed {
  border: 0.5px solid rgba(254, 254, 254, 0.3);
  background: rgba(255, 255, 255, 0.7);
  // box-shadow: rgba(61, 61, 61, 0.404) 0px 6px 12px -2px,
  //     rgba(0, 0, 0, 0.453) 0px 3px 7px -3px;
  box-shadow: 3px 3px 40px 3px rgba(30, 30, 30, 0.7);
  border-radius: 12px;
  backdrop-filter: blur(60px);
  -webkit-backdrop-filter: blur(60px);
  filter: brightness(1);
  position: fixed;
  height: 130px;
  max-width: 200px;
  min-width: 200px;
  left: 50%;
  top: 5%;
  margin-left: -100px;
}

.fixed2 {
  border: 0.5px solid rgba(254, 254, 254, 0.3);
  background: rgba(255, 255, 255, 0.7);
  // box-shadow: rgba(61, 61, 61, 0.404) 0px 6px 12px -2px,
  //     rgba(0, 0, 0, 0.453) 0px 3px 7px -3px;
  box-shadow: 3px 3px 40px 3px rgba(30, 30, 30, 0.7);
  border-radius: 12px;
  backdrop-filter: blur(60px);
  -webkit-backdrop-filter: blur(60px);
  filter: brightness(1);
  position: fixed;
  height: 100px;
  max-width: 500px;
  min-width: 500px;
  left: 50%;
  top: 115%;
  margin-left: -250px;
}

.fixed3 {
  border: 0.5px solid rgba(254, 254, 254, 0.3);
  background: rgba(255, 255, 255, 0.7);
  // box-shadow: rgba(61, 61, 61, 0.404) 0px 6px 12px -2px,
  //     rgba(0, 0, 0, 0.453) 0px 3px 7px -3px;
  box-shadow: 3px 3px 40px 3px rgba(30, 30, 30, 0.7);
  border-radius: 12px;
  backdrop-filter: blur(60px);
  -webkit-backdrop-filter: blur(60px);
  filter: brightness(1);
  position: fixed;
  width: 500px;
  height: auto;
  max-height: 700px;
  overflow: auto;
  left: 50%;
  top: 120%;
  margin-left: -250px;
}
</style>
